export default __webpack_public_path__ + "static/media/uploader-tandem-3.f0138b56.png";